/** Mirrors IssueCommentDto.attachmentType in the assets API. */
export enum IssueCommentAttachmentType {
  IMAGE = 'IMAGE',
  AUDIO = 'AUDIO',
}
